import { render } from "./ProjectReviews.vue?vue&type=template&id=4f22e740&scoped=true"
import script from "./ProjectReviews.vue?vue&type=script&lang=js"
export * from "./ProjectReviews.vue?vue&type=script&lang=js"

import "./ProjectReviews.vue?vue&type=style&index=0&id=4f22e740&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f22e740"]])

export default __exports__